import { OrgListType } from "../listselect/Type";

export const filteredOrgUserList = (orgUserList: OrgListType[], search: string) => {
    if (search === "") {
        return orgUserList;
    }
    return orgUserList.filter(orgUser => orgUser.name.toLowerCase().includes(search.toLowerCase()));
}
